import { BaseRestDataProvider } from './BaseRestDataProvider';
import { BankAccount } from '../models/BankAccount';

export class BankAccountRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/bank-accounts');
  }

  getAll(): Promise<BankAccount[]> {
    return this.get<BankAccount[]>(``);
  }

  getById(id: string): Promise<BankAccount> {
    return this.get<BankAccount>(`/${id}`);
  }

  getByLedgerCode(ledgerCode: string): Promise<BankAccount> {
    return this.get<BankAccount>(`/by-ledger-code/${encodeURIComponent(ledgerCode)}`);
  }

  add(account: BankAccount): Promise<BankAccount> {
    return this.post<BankAccount>(``, account);
  }

  update(id: string, account: BankAccount): Promise<void> {
    return this.put<void>(`/${id}`, account);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { BankAccount };

